import { ReactNode } from "react";
import { Modal, IconButton } from "@mui/material";

import "./style.scss";
import { ReactComponent as CloseIcon } from "../../assets/crossIcon.svg";

export const ModalTemplate = ({
    children,
    open,
    width,
    height,
    showClose = true,
    handleClose
}: {
    children: ReactNode;
    open: boolean;
    width?: number;
    height?: number;
    showClose?: boolean;
    handleClose?: (arg1: boolean) => void;
}) => {
    const style = { ...(width ? { maxWidth: width } : {}), ...(height ? { height: height } : {}) };

    const handleCloseClick = () => {
        if (handleClose) {
            handleClose(false);
        }
    };

    return (
        <Modal className="modal-template" open={open}>
            <div className="modal-template-view" style={style}>
                {showClose && (
                    <IconButton className="modal-template-close-button" onClick={handleCloseClick}>
                        <CloseIcon />
                    </IconButton>
                )}
                {children}
            </div>
        </Modal>
    );
};
